import { gridPaths } from '@/shared/hooks';
import { createEntityGridConfig, type GridConfig } from '@/ui/composites/grid/gridConfigFactory';
import { fetchPipelinesGrid } from './gridQuery';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { GridFilterModel, GridSortModel } from '@/ui/primitives';
import type { PipelineListItemDto } from '@flowqa/shared';

export const pipelinesGridConfig = ({
  projectId,
  organisationId,
  fixedFilters,
  initialSortModel = [{ field: 'latestBuildTimestamp', sort: 'desc' }],
  initialFilterModel,
  persistKey,
  includeDeltas = true,
  syncStateToUrl = false,
}: {
  projectId?: string | null;
  organisationId?: string | null;
  fixedFilters?: GridQueryInput['filters'];
  initialSortModel?: GridSortModel;
  initialFilterModel?: GridFilterModel;
  persistKey?: string | null;
  includeDeltas?: boolean;
  syncStateToUrl?: boolean;
} = {}): GridConfig<PipelineListItemDto> =>
  createEntityGridConfig<PipelineListItemDto>({
    path: gridPaths.pipelines,
    queryFn: async (input) =>
      await fetchPipelinesGrid(projectId, organisationId, input, includeDeltas),
    noRowsText: 'No pipelines found',
    fixedFilters,
    initialSortModel,
    initialFilterModel,
    persistKey,
    defaultPersistKey: 'pipelines-v2',
    syncStateToUrl,
  });

export type PipelinesGridConfig = ReturnType<typeof pipelinesGridConfig>;
